/* Pizzalovers Startseite – Winter-Karten: Bild bekommt denselben Link wie der Pfeil darunter (Claudio 17.10.2026).
   Krown verlinkt bei promotion-cards nur die ganze Karte, wenn KEIN Button-Text gesetzt ist; der Pfeil-Link soll bleiben. */
(function () {
  function init() {
    document.querySelectorAll('[id$="__promotion_cards_cDmNGP"] .card').forEach(function (card) {
      var img = card.querySelector('.card__image');
      var btn = card.querySelector('.card__text a.button, .card__text a[href]');
      var href = btn && btn.getAttribute('href');
      if (!img || !href || img.closest('a')) return;
      var a = document.createElement('a');
      a.href = href;
      a.className = 'pl-card-image-link';
      a.setAttribute('aria-label', btn.textContent.trim());
      img.parentNode.insertBefore(a, img);
      a.appendChild(img);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
